import Cookies from 'js-cookie'

import { platformsDTO } from '@/utils/platformsDTO'

const app = {
  state: {
    sidebar: {
      opened: !!+Cookies.get('sidebarStatus'),
      smallDevice: window.matchMedia('(max-width: 767px)').matches
    },
    version: '',
    profile: '',
    platforms: {
      insertPlatforms: [],
      leafletPlatforms: []
    },
    articlesDataFeature: false,
    leafletScrapperFeature: false
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened && !state.sidebar.smallDevice) {
        Cookies.set('sidebarStatus', 0, { expires: 365 })
      } else if (!state.sidebar.smallDevice) {
        Cookies.set('sidebarStatus', 1, { expires: 365 })
      }

      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: state => {
      Cookies.set('sidebarStatus', 0, { expires: 365 })
      state.sidebar.opened = false
    },
    OPEN_SIDEBAR: state => {
      Cookies.set('sidebarStatus', 1, { expires: 365 })
      state.sidebar.opened = true
    },
    SET_SYSTEM_VERSION: (state, version) => {
      state.version = version
    },
    SET_PLATFORMS: (state, platforms) => {
      state.profile = platforms.profile
      state.platforms = {
        insertPlatforms: platforms.insertPlatforms,
        leafletPlatforms: platformsDTO(platforms.leafletPlatforms)
      }
      state.articlesDataFeature = platforms.articlesDataFeature
      state.leafletScrapperFeature = platforms.leafletScrapperFeature
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }) {
      commit('CLOSE_SIDEBAR')
    },
    openSideBar({ commit }) {
      commit('OPEN_SIDEBAR')
    },
    setSystemVersion({ commit }, systemVersion) {
      commit('SET_SYSTEM_VERSION', systemVersion)
    },
    setSystemPlatforms({ commit }, platforms) {
      commit('SET_PLATFORMS', platforms)
    }
  }
}

export default app
